function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none"
}, React.createElement("path", {
  fill: "#EB9200",
  d: "M72.125 54.879L42.477 3.374c-2.528-4.499-9.423-4.499-11.951 0L.878 54.879C-1.65 59.377 1.568 65 6.854 65H65.92c5.515-.225 8.733-5.623 6.205-10.121z",
  transform: "matrix(-1 0 0 1 73 0)"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M36 8L65 58 7 58z",
  transform: "matrix(-1 0 0 1 73 0)"
}), React.createElement("g", {
  fill: "#EB9200",
  transform: "matrix(-1 0 0 1 73 0) translate(30 27)"
}, React.createElement("path", {
  d: "M.196 5.271l2.202 11.564c.275 1.309 1.652 2.4 3.579 2.4 1.651 0 3.303-1.091 3.578-2.4L11.757 5.27c.55-2.836-2.202-5.236-5.78-5.236-3.579 0-6.056 2.4-5.78 5.236z"
}), React.createElement("ellipse", {
  cx: 5.977,
  cy: 24.253,
  rx: 3.303,
  ry: 2.618
})));

var SvgError = function SvgError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 73,
    height: 65,
    viewBox: "0 0 73 65",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error.0787464b.svg";
export { ForwardRef as ReactComponent };